import React from "react";

const InvoiceFooter = ({ items, currency, companyDetails }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const subtotal = items.reduce((sum, item) => {
    const discountedPrice = Math.max(0, item.price - (item.discount || 0));
    return sum + (discountedPrice * item.quantity);
  }, 0);

  const totalDiscount = items.reduce((sum, item) => 
    sum + ((item.discount || 0) * item.quantity), 0
  );

  const total = subtotal;

  return (
    <div className="invoice-footer mt-6 border-t border-gray-200 pt-4">
      <div className="totals mb-4">
        <div className="space-y-2">
          {/* Subtotal */}
          <div className="total-row flex justify-between text-gray-700">
            <span className="font-medium text-sm">Subtotal:</span>
            <span className="font-medium text-sm">{formatCurrency(subtotal)}</span>
          </div>

          {/* Discount */}
          {totalDiscount > 0 && (
            <div className="total-row flex justify-between text-red-600">
              <span className="font-medium text-sm">Discount:</span>
              <span className="font-medium text-sm">-{formatCurrency(totalDiscount)}</span>
            </div>
          )}

          {/* Total */}
          <div className="total-row flex justify-between  font-semibold text-base border-t border-gray-300 pt-2">
            <span>Total:</span>
            <span>{formatCurrency(total)}</span>
          </div>
        </div>
      </div>

      {/* Payment Information */}
      {companyDetails && (
        <div className="payment-info bg-gray-100 border border-gray-200 rounded-lg p-3">
          <h4 className="text-sm font-semibold  mb-2">Payment Information</h4>
          <p className="text-xs text-gray-700 truncate">Bank: {companyDetails.bank_name}</p>
          <p className="text-xs text-gray-700 truncate">Account: {companyDetails.account_number}</p>
          <p className="text-xs text-gray-700 truncate">Name: {companyDetails.account_name}</p>
        </div>
      )}
    </div>
  );
};

export default InvoiceFooter;